function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.93 9.071a1.25 1.25 0 011.767 0L23.07 21.445a1.25 1.25 0 11-1.768 1.768L8.93 10.84a1.25 1.25 0 010-1.768z",
  fill: "#8390AB"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.071 9.071a1.25 1.25 0 010 1.768L10.697 23.213a1.25 1.25 0 11-1.768-1.768L21.303 9.071a1.25 1.25 0 011.768 0z",
  fill: "#8390AB"
});

var SvgIconCloseLight = function SvgIconCloseLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDEuMjVDMCAwLjU1OTY0NCAwLjU1OTY0NCAwIDEuMjUgMEgxOC43NUMxOS40NDA0IDAgMjAgMC41NTk2NDQgMjAgMS4yNUMyMCAxLjk0MDM2IDE5LjQ0MDQgMi41IDE4Ljc1IDIuNUgxLjI1QzAuNTU5NjQ0IDIuNSAwIDEuOTQwMzYgMCAxLjI1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS44MTI5OSA4LjE4NzEzKSByb3RhdGUoNDUpIiBmaWxsPSIjODM5MEFCIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAxLjI1QzAgMC41NTk2NDQgMC41NTk2NDQgMCAxLjI1IDBIMTguNzVDMTkuNDQwNCAwIDIwIDAuNTU5NjQ0IDIwIDEuMjVDMjAgMS45NDAzNiAxOS40NDA0IDIuNSAxOC43NSAyLjVIMS4yNUMwLjU1OTY0NCAyLjUgMCAxLjk0MDM2IDAgMS4yNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzLjk1NTEgOS45NTQ5Nikgcm90YXRlKDEzNSkiIGZpbGw9IiM4MzkwQUIiLz4KPC9zdmc+Cg==";
export { SvgIconCloseLight as ReactComponent };